<div class="main-content">
  <app-header [title]="'HEADER.TITLE_NEW_REQUEST' | translate" [subtitle]="'HEADER.SUBTITLE_NEW_REQUEST' | translate" />

  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      @if (!showSuccess && !showError) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'info-white'"
          [iconColor]="'#e30714'"
          [iconHeight]="'45px'"
        >
          <form
            class="form-container request-form d-flex flex-column flex-md-row"
            (ngSubmit)="submitForm()"
            [formGroup]="form"
          >
            <div class="form-section personal-info-section w-100">
              <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
                <div class="d-flex align-items-center p-2">
                  <img class="section-image" src="../../assets/icon/user.svg" alt="user" />
                </div>
                <div class="form-title-text-container">
                  <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                    {{ 'PERSONAL_INFO_FORM.PERSONAL_INFORMATION' | translate }}
                  </p>
                </div>
              </div>
              <div class="input-wrapper">
                <label for="name"> {{ 'PERSONAL_INFO_FORM.NAME' | translate }}*</label>
                <app-icam-input
                  label="{{ 'PERSONAL_INFO_FORM.NAME' | translate }}"
                  inputId="name"
                  formControlName="firstName"
                  [isSlim]="true"
                  [required]="true"
                  [ngClass]="isLight ? 'light' : 'dark'"
                />
              </div>
              <div class="input-wrapper">
                <label for="last_name">{{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}*</label>
                <app-icam-input
                  label="{{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}"
                  inputId="last_name"
                  formControlName="lastName"
                  [isSlim]="true"
                  [required]="true"
                  [ngClass]="isLight ? 'light' : 'dark'"
                />
              </div>
              <div class="input-wrapper">
                <label for="email">Email*</label>
                <app-icam-input
                  label="Email"
                  inputId="email"
                  formControlName="email"
                  [isSlim]="true"
                  inputType="email"
                  [required]="true"
                  [ngClass]="isLight ? 'light' : 'dark'"
                />
              </div>
              <div class="input-wrapper">
                <label for="phone">{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}</label>
                <app-icam-input
                  label="{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}"
                  inputId="phone"
                  [isSlim]="true"
                  inputType="tel"
                  [required]="false"
                  formControlName="phone"
                  [ngClass]="isLight ? 'light' : 'dark'"
                />
              </div>
              <div class="input-wrapper">
                <p class="required-info">*{{ 'PERSONAL_INFO_FORM.REQUIRED' | translate }}</p>
              </div>
            </div>
            <div class="form-section access-info-section w-100">
              <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
                <div class="d-flex align-items-center p-2">
                  <img class="section-image" src="../../assets/icon/headset.svg" alt="headset" />
                </div>
                <div class="form-title-text-container">
                  <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                    {{ 'PERSONAL_INFO_FORM.PERSONAL_REQUEST' | translate }}
                  </p>
                </div>
              </div>
              <div class="input-wrapper" *appHasRole="['PARTNER', 'ADMIN']">
                <div class="form-group">
                  <label for="mySelect">{{ 'PERSONAL_INFO_FORM.COMPANY_NAME' | translate }}</label>
                  <select
                    id="companyNameSelect"
                    class="form-select rounded-0 slim"
                    formControlName="locationId"
                    [ngClass]="isLight ? 'light' : 'dark'"
                    (change)="onSelectedCompanyName($event)"
                  >
                    <option value="">
                      {{ 'COMMON.CHOOSE_VALUE' | translate }}
                    </option>
                    @if (companyNameList$ | async; as companyNameList) {
                      @for (option of companyNameList; track option) {
                        <option [value]="option.locationId">
                          {{ option.name }}
                        </option>
                      }
                    }
                  </select>
                </div>
              </div>
              <div class="input-wrapper">
                <div class="form-group">
                  <label for="mySelect">{{ 'PERSONAL_INFO_FORM.NUMBER' | translate }}</label>
                  <select
                    id="mySelect"
                    class="form-select rounded-0 slim"
                    formControlName="serialNumber"
                    [ngClass]="isLight ? 'light' : 'dark'"
                  >
                    <option value="">
                      {{ 'COMMON.CHOOSE_VALUE' | translate }}
                    </option>
                    @if (serialNumberList$ | async; as list) {
                      @if (list && list.length === 1) {
                        @for (option of list; track option) {
                          <option [selected]="option" [value]="option">
                            {{ option }}
                          </option>
                        }
                      } @else {
                        @for (option of list; track option) {
                          <option [value]="option">
                            {{ option }}
                          </option>
                        }
                      }
                    }
                  </select>
                </div>
              </div>
              <div class="input-wrapper">
                <div class="form-group">
                  <label for="error_code">{{ 'REQUEST.REQUEST_TYPE' | translate }}*</label>
                  <select
                    formControlName="reason"
                    class="form-select rounded-0 slim"
                    [ngClass]="isLight ? 'light' : 'dark'"
                  >
                    <option value="">
                      {{ 'COMMON.CHOOSE_VALUE' | translate }}
                    </option>
                    @for (type of reasonsList; track type) {
                      <option [value]="type.value">
                        {{ 'REQUEST.TYPES.' + type.label | translate }}
                      </option>
                    }
                  </select>
                </div>
              </div>
              <div class="input-wrapper">
                <label for="description">{{ 'PERSONAL_INFO_FORM.DESCRIPTION' | translate }}*</label>
                <textarea
                  label="description"
                  inputId="error_code"
                  formControlName="description"
                  rows="6"
                  placeholder="{{ 'REQUEST_DESCRIPTION_PLACEHOLDER' | translate }}"
                  [maxlength]="MAXLENGTH_TEXTAREA"
                ></textarea>
                <p class="char-counter">{{ form.get('description')?.value.length || 0 }} / {{ MAXLENGTH_TEXTAREA }}</p>
              </div>
              <div class="d-flex align-items-center gap-2">
                <label for="file-upload" class="custom-file-upload" [ngClass]="isLight ? 'light' : 'dark'">
                  <app-icam-icon iconName="attachment" />
                  {{ 'PERSONAL_INFO_FORM.ATTACHMENT' | translate }}
                </label>
                <div
                  class="popover-trigger"
                  ngbPopover="{{ 'acceptedFiles' | translate }}{{ 'docs' | translate }}"
                  triggers="mouseenter:mouseleave"
                  popoverClass="icam-popover {{ isLight ? 'light' : 'dark' }}"
                >
                  <app-icam-icon [iconName]="'info-circle'" />
                </div>
              </div>
              <input
                id="file-upload"
                type="file"
                (change)="onFileSelect($event)"
                style="display: none"
                accept=".jpeg, .jpg, .png, .pdf, .doc, .docx, .xls, .xlsx, .odt, .ods"
              />
              @if (this.form.value.attachmentFileName) {
                <p class="text-muted">
                  {{ form.value.attachmentFileName }}
                  <small
                    class="text-decoration-underline"
                    role="button"
                    (click)="onResetUpdateFile()"
                    (keydown.enter)="onResetUpdateFile()"
                    tabindex="0"
                  >
                    ({{ 'REMOVE' | translate }})
                  </small>
                </p>
              }
              <!-- <button type="submit" class="btn btn-danger mt-4 btn-block">{{ 'REQUEST.SEND_REQUEST' | translate
            }}</button> -->
              <button
                type="submit"
                id="button-save"
                class="button-form-submit"
                [class.disabled]="!form.valid || isLoading"
                [disabled]="!form.valid || isLoading"
              >
                @if (isLoading) {
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status"></div>
                  </div>
                } @else {
                  {{ 'REQUEST.SEND_REQUEST' | translate }}
                }
              </button>
            </div>
          </form>
        </app-icam-container>
      }
      @if (showSuccess) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'info-white'"
          [iconColor]="'#00A5A9'"
          [iconHeight]="'45px'"
        >
          <div class="central-content w-100">
            <h1 class="ticket-title-success mt-5">
              {{ 'REQUEST.OPENED_REQUEST' | translate }}
            </h1>
            <p class="ticket-subtitle my-5">
              {{ 'REQUEST.OPENED_REQUEST_DESCRIPTION' | translate }}
            </p>
            <div class="d-flex justify-content-center mt-5">
              <app-back-button [linkText]="'REQUEST.BACK_TO_NEW_REQUEST'" (click)="goBack()" />
            </div>
          </div>
        </app-icam-container>
      }

      @if (showError) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'info-white'"
          [iconColor]="'#e30714'"
          [iconHeight]="'45px'"
        >
          <div class="central-content w-100">
            <h1 class="ticket-title-error">
              {{ 'REQUEST.OPENED_REQUEST_ERROR' | translate }}
            </h1>
            <p class="ticket-subtitle my-5">
              {{ 'REQUEST.OPENED_REQUEST_DESCRIPTION_ERROR' | translate }}
            </p>
            <div class="d-flex justify-content-center mt-5">
              <app-back-button [linkText]="'REQUEST.BACK_TO_NEW_REQUEST'" (click)="goBack()" />
            </div>
          </div>
        </app-icam-container>
      }
      @if (!showSuccess && !showError) {
        <div class="mt-4 mb-4">
          @if (!showSuccess && !showError) {
            <app-back-button [linkText]="'REQUEST.BACK_TO_REQUEST'" (click)="goBack()" />
          }
        </div>
      }
    </div>
  </div>
</div>
